import React, { useContext } from "react";
import { Text, BlockStack, InlineStack } from "@shopify/polaris";
import TimeService from "app/setup/modules/operator/features/_fulfillment/generic/consignmentShip/consignmentShip";
import { FulfillmentContext } from "app/setup/modules/operator/features/_fulfillment/context";

const HybridTimeService = () => {
  const { cms } = useContext(FulfillmentContext);
  return (
    <div className="hybridTimeService">
      <BlockStack gap="10">
        <InlineStack>
          <Text variant="headingMd" as="h2">
            {cms("hybrid.timeService.title")}
          </Text>
          <br />
          <Text as="span" tone="subdued">
            {cms("hybrid.timeService.description")}
          </Text>
        </InlineStack>
      </BlockStack>
      <br />
      <TimeService method="hybridTimeService" />
    </div>
  );
};

export default HybridTimeService;
